module.exports = __webpack_public_path__ + "static/img/jq2.f017853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jq2.png
// module id = rghk
// module chunks = 1